import {useMemo} from "react";
import {useConsumerUser} from "~/contexts/user/ConsumerUserContext";
import {useAccount} from "./useAccount";

const lowestOf = (...values: (number | undefined)[]): number | undefined => {
  const defined = values.filter((value): value is number => value != null);
  return defined.length ? Math.min(...defined) : undefined;
};

export const useBestSavings = () => {
  const {preLoginContext} = useConsumerUser();
  const {account} = useAccount({includeOffers: true});

  const lowestMonthlyInstallment = useMemo(() => {
    const fromPreLogin = lowestOf(
      preLoginContext?.lowest_monthly_installment_size,
      preLoginContext?.lowest_hardship_installment_size
    );

    const fromAccount = lowestOf(account?.lowest_monthly_installment_size, account?.lowest_hardship_installment_size);

    return fromPreLogin ?? fromAccount;
  }, [preLoginContext, account]);

  return {lowestMonthlyInstallment};
};
